<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button
                :disabled="isLoading"
                :display-warning="false"
                v-if="renderBackButton"
            />
            <template v-if="renderActionButton && Boolean(resource)">
                <x-quick-action-button
                    :url="`/admin/gatherings?group_id=${resource.id}`"
                    icon="calendar-check-o"
                    title="Absensi"
                    :disabled="isLoading"
                    v-if="can('viewGatherings')"
                />
                <x-quick-edit-button
                    :url="`/admin/groups/${resource.id}/edit`"
                    :disabled="isLoading"
                    v-if="can('updateGroups')"
                />
            </template>
        </template>
        <group-form
            id="group-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource"
        />
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XQuickActionButton from "../../components/XQuickActionButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";
import {
    getAllowedGroupIds,
    handleGeneralXhrError,
    hasRestrictedGroupViewPermission,
} from "../../helpers";
import PermissionMixin from "../../mixins/PermissionMixin";
import GroupForm from "./GroupForm.vue";
import { parseMembers } from "./helpers";

export default {
    components: {
        XPage,
        XBackButton,
        GroupForm,
        XQuickActionButton,
        XQuickEditButton,
    },
    computed: {
        pageTitle() {
            let title = ["Detail Group"];

            if (this.resource) {
                title.push(this.resource.label);
            }

            return title.join(" | ");
        },
    },
    created() {
        this.fetchResource();
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            renderActionButton: false,
            renderBackButton: true,
            resource: null,
        };
    },
    methods: {
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/groups/${this.$route.params.id}`, {
                    params: {
                        append: ["enter_trigger", "exit_trigger"],
                        load: ["category", "members", "roles"],
                    },
                })
                .then((response) => {
                    const data = response.data.data;
                    this.resource = {
                        ...data,
                        members: parseMembers(data.members),
                    };
                    if (data.enter_trigger) {
                        this.resource.enter_trigger.active = true;
                    }
                    if (data.exit_trigger) {
                        this.resource.exit_trigger.active = true;
                    }
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
    },
    mixins: [PermissionMixin],
    mounted() {
        this.renderActionButton =
            hasRestrictedGroupViewPermission() &&
            getAllowedGroupIds().length == 1;
        this.renderBackButton = !this.renderActionButton;
    },
};
</script>
